import React, { useRef } from "react";
import { Images, Services } from "../../../Controller";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IoArrowBack, IoArrowForwardOutline } from "react-icons/io5";
import { Carousel } from "antd";
function DashboardCommon({ banners }) {
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const serviceRef = useRef();

  const scrollLeft = () => {
    if (serviceRef.current) {
      serviceRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (serviceRef.current) {
      serviceRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };
  const checkCredoStatus = () => {
    if (!profiledetail.credo_aeps_onboard) {
      return "/banking/aeps2-onboard";
    } else if (!profiledetail.credo_aeps_status) {
      return "/banking/waiting";
    } else if (
      profiledetail.credo_aeps_onboard &&
      profiledetail.credo_aeps_status
    ) {
      return "/banking/aeps2-2fa";
    }
  };
  const navigate = useNavigate();
  const checkDigiStatus = () => {
    if (
      profiledetail.digio_kyc === "0" ||
      profiledetail.digio_kyc === "2" ||
      profiledetail.digio_kyc === "3"
    ) {
      return true;
    }
  };
  const checkWithdrawalStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    }
    //  else if (withdrawalTime === 0) {
    //   return "/banking/aeps";
    // }
    else {
      return to;
    }
  };
  return (
    <div className="m-4">
      {" "}
      {/* md:grid-cols-3 lg:grid-cols-[30%_16.4%_16.4%_16.4%_16.4%_] */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {" "}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 place-items-start gap-3">
          <div
            className="shadow-[0px_2px_2px_#ccdcff] cursor-pointer p-6 border-gray-300  border bg-white h-36 w-full rounded-xl"
            onClick={() => navigate("/personal-info")}
          >
            <p className="text-rgbaprimary4 text-xl font-bold capitalize">
              Hi , {profiledetail.first_name} {profiledetail.last_name}
            </p>
            <p className="text-rgbaprimary7 text-lg">
              Ready to earn with Pay Near Solution Service
            </p>
          </div>

          <div
            className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
            onClick={() =>
              navigate(
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("8")
                    ? checkWithdrawalStatus("/banking/aeps-cash-withdrawl")
                    : "/not-available",
                {
                  state: { from: "/banking/aeps-cash-withdrawl", type: "aeps" },
                },
              )
            }
          >
            <img
              src={Images.aeps}
              className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
              alt="Aeps"
            />
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              AEPS
            </p>
          </div>

          <div
            className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
            onClick={() =>
              navigate(
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("8")
                    ? checkWithdrawalStatus("/banking/aeps-cash-deposit")
                    : "/not-available",
              )
            }
          >
            <img
              src={Images.cashDeposit}
              className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
              alt="DMT"
            />
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              Cash Deposit
            </p>
          </div>

          <div
            className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
            onClick={() =>
              navigate(
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("9")
                    ? "/express-payout"
                    : "/not-available",
              )
            }
          >
            <img
              src={Images.DMT}
              className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
              alt="DMT"
            />
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              Express DMT
            </p>
          </div>

          <div
            onClick={() =>
              navigate(
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("21")
                    ? "/upi-dmt"
                    : "/not-available",
              )
            }
            className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
          >
            <img
              src={Images.recharges}
              className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
              alt="credit card"
            />
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              UPI DMT
            </p>
          </div>
        </div>
        <div>
          <Carousel autoplay>
            {banners?.length > 0 &&
              banners?.map((i, id) => {
                return (
                  <div key={id}>
                    <p className="text-rgbaprimary7 flex justify-center text-base font-semibold m-4">
                      {i.title}
                    </p>

                    <img
                      src={i.image}
                      className="w-full rounded-lg"
                      alt={`banner${id}`}
                    />
                    <p className="text-center m-2 text-rgbaprimary7 font-medium">
                      {i.subtitle}
                    </p>
                  </div>
                );
              })}
          </Carousel>
        </div>
      </div>
      <p className="text-rgbaprimary7 flex justify-start text-lg  font-bold mt-2">
        Our Services
      </p>
      <div className="relative">
        <div ref={serviceRef} className="w-full overflow-x-auto scrollbar-hide">
          <div className="flex gap-5 w-full p-4">
            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("25")
                      ? checkCredoStatus()
                      : "/not-available",
                )
              }
            >
              <img
                src={Services.insurance}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                AEPS 2
              </p>
            </div>

            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("1")
                      ? "/bbps?service=Credit Card"
                      : "/not-available",
                )
              }
            >
              <img
                src={Services.creditCardBill}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="recharge"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                Credit Card Bill
              </p>
            </div>

            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  checkDigiStatus()
                    ? "/kycStatus"
                    : profiledetail.dmt_kyc === "1" &&
                        memberServices.includes("4")
                      ? "/dmt/remitters"
                      : profiledetail.dmt_kyc !== "1" &&
                          memberServices.includes("4")
                        ? "/dmt/submitKyc"
                        : "/not-available",
                )
              }
            >
              <img
                src={Services.express_payout}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                DMT
              </p>
            </div>

            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("1")
                      ? "/bbps?service=Electricity"
                      : "/not-available",
                )
              }
            >
              <img
                src={Services.elecbill}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                Electricity Bill
              </p>
            </div>
            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("1")
                      ? "/bbps?service=Fastag"
                      : "/not-available",
                )
              }
            >
              <img
                src={Services.fastag}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                Fastag
              </p>
            </div>
            {/* <div
          className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl "
          onClick={() =>
            navigate(
              checkDigiStatus()
                ? "/kycStatus"
                : memberServices.includes("1")
                ? "/recharge"
                : "/not-available"
            )
          }
        >
          <img
            src={Services.credit_report}
           className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
            alt="DMT"
          />
         <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
            Credit Report
          </p>
        </div> */}
            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("1")
                      ? "/bbps?service=Insurance"
                      : "/not-available",
                )
              }
            >
              <img
                src={Services.insurance}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                Insurance
              </p>
            </div>

            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() => navigate("/panServices")}
            >
              <img
                src={Services.insurance}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                PAN Services
              </p>
            </div>
            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("1")
                      ? "/recharge"
                      : "/not-available",
                )
              }
            >
              <img
                src={Services.mobileRecharge}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                Recharges
              </p>
            </div>
            {/* <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl ">
              <img
                src={Services.POS}
               className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
             <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                POS
              </p>
            </div>
            <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl ">
              <img
                src={Services.cms}
               className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
             <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                CMS
              </p>
            </div>
            <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl ">
              <img
                src={Services.loansBilss}
               className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                Loans & Credit Card
              </p>
            </div>
            <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl ">
              <img
                src={Services.travel}
               className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="DMT"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                Travel Booking
              </p>
            </div> */}
            <div
              className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("1")
                      ? "/bbps"
                      : "/not-available",
                )
              }
            >
              <img
                src={Services.utility}
                className="flex justify-center m-auto  w-12 text-rgbaprimary6 h-8 sm:h-10 md:12 "
                alt="credit card"
              />
              <p className="text-rgbaprimary7 flex justify-center text-center text-xs leading-3  font-bold mt-4">
                Utility Bills
              </p>
            </div>
          </div>
        </div>
        <p
          onClick={scrollLeft}
          className="absolute z-10 left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-rgbaprimary2 border-2 border-rgbaprimary8 flex justify-center items-center cursor-pointer"
        >
          <IoArrowBack size={20} />
        </p>
        <p
          onClick={scrollRight}
          className="absolute z-10 right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-rgbaprimary2 border-2 border-rgbaprimary8 flex justify-center items-center cursor-pointer"
        >
          <IoArrowForwardOutline size={20} />
        </p>
      </div>
    </div>
  );
}
export default DashboardCommon;
